import React from 'react';
import {
  Card, CardContent, Grid, Box,
} from '@mui/material';
import { observer } from 'mobx-react';
import { AppGame } from '@gamiphy/bl/game';
import { useTheme } from '@mui/material/styles';
import { Trans } from '@gamiphy/react-i18n';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';

type Props = {
  appGame: AppGame,
}

const HomeGameCard: React.FC<Props> = observer(({ appGame }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#f8f8f8',
        },
      }}
      onClick={() => {
        UiStore.setPage(Pages.game);
        UiStore.setShowGame(true);
      }}
    >
      <CardContent>
        <Grid container>
          <Grid container justifyContent="space-between" size={12} sx={{ mb: 1 }}>
            <Grid size={10} sx={{ mr: 1, fontSize: '14px', fontWeight: 500 }}>
              <Trans
                i18nKey="real.game.description"
                defaults="Play and get double {{, gems}}"
                values={{}}
              />
            </Grid>
            <Grid size={1}>
              {theme.direction === 'rtl' ? <KeyboardArrowLeft fontSize="large" /> : <KeyboardArrowRight fontSize="large" />}
            </Grid>
          </Grid>
          <Grid size={12}>
            <Box
              component="img"
              alt=""
              sx={{
                width: '100%',
                maxHeight: '10.4rem',
                objectFit: 'cover',
                borderRadius: '0.8rem',
              }}
              src={appGame?.image}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default HomeGameCard;
